import { Seo } from '../components/Seo';
import { FaqBlock } from '../components/FaqBlock';
import { PAGES } from '../lib/config';
import { PRICING_FAQ } from '../lib/content';
import { track } from '../lib/analytics';
import {
  softwareApplicationSchema,
  breadcrumbsSchema,
  websiteSchema,
  organizationSchema,
} from '../lib/schema';

const page = PAGES.find((p) => p.path === '/pricing')!;

export function PricingPage() {
  return (
    <>
      <Seo
        page={page}
        schemas={[
          websiteSchema(),
          organizationSchema(),
          softwareApplicationSchema(),
          breadcrumbsSchema(page),
        ]}
      />
      <section className="bg-gradient-to-b from-primary-50/10 to-bg-base px-4 py-16 text-center sm:px-6 lg:px-8">
        <h1 className="text-4xl font-extrabold tracking-tight text-text-primary sm:text-5xl">
          {page.h1}
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-text-secondary">{page.subhead}</p>
      </section>

      <section className="mx-auto max-w-5xl px-4 pb-16 sm:px-6 lg:px-8">
        <div className="grid gap-6 sm:grid-cols-2">
          <div className="rounded-2xl border border-border-subtle bg-bg-elevated p-6 shadow-sm sm:p-8">
            <h2 className="text-xl font-bold text-text-primary">Free</h2>
            <p className="mt-2 text-sm text-text-secondary">For casual use</p>
            <p className="mt-4 text-4xl font-extrabold text-text-primary">$0</p>
            <ul className="mt-6 space-y-3 text-sm text-text-secondary">
              <li className="flex items-start gap-2">
                <span className="text-success">✓</span> 2 images per day
              </li>
              <li className="flex items-start gap-2">
                <span className="text-success">✓</span> 2× upscale only
              </li>
              <li className="flex items-start gap-2">
                <span className="text-success">✓</span> Watermarked output with limited resolution
              </li>
              <li className="flex items-start gap-2">
                <span className="text-success">✓</span> No batch, no history
              </li>
              <li className="flex items-start gap-2">
                <span className="text-success">✓</span> JPG/PNG/WebP support
              </li>
              <li className="flex items-start gap-2">
                <span className="text-success">✓</span> No sign-up required
              </li>
            </ul>
            <button
              className="mt-8 w-full rounded-xl border border-border-subtle bg-bg-elevated-2 py-3 font-semibold text-text-primary hover:bg-bg-elevated-3"
              onClick={() => track('cta_click', { location: 'pricing_free_card', target: 'start_free' })}
            >
              Start for Free
            </button>
          </div>

          <div className="relative rounded-2xl border border-primary-100 bg-bg-elevated p-6 shadow-lg sm:p-8">
            <span className="absolute -top-3 right-6 rounded-full bg-primary px-3 py-1 text-xs font-semibold text-white">
              Most Popular
            </span>
            <h2 className="text-xl font-bold text-text-primary">Pro Monthly</h2>
            <p className="mt-2 text-sm text-text-secondary">For creators and professionals</p>
            <p className="mt-4 text-4xl font-extrabold text-text-primary">$9.90</p>
            <p className="text-sm text-text-secondary">per month</p>
            <ul className="mt-6 space-y-3 text-sm text-text-secondary">
              <li className="flex items-start gap-2">
                <span className="text-success">✓</span> 100 images per month
              </li>
              <li className="flex items-start gap-2">
                <span className="text-success">✓</span> 2× previews now
              </li>
              <li className="flex items-start gap-2">
                <span className="text-success">✓</span> 4×/8× planned for Pro
              </li>
              <li className="flex items-start gap-2">
                <span className="text-success">✓</span> High-resolution, watermark-free output
              </li>
              <li className="flex items-start gap-2">
                <span className="text-success">✓</span> Batch processing (planned)
              </li>
              <li className="flex items-start gap-2">
                <span className="text-success">✓</span> Faster processing
              </li>
            </ul>
            <button
              className="mt-8 w-full rounded-xl bg-primary py-3 font-semibold text-white hover:bg-primary-hover"
              onClick={() => track('pricing_click', { location: 'pricing_monthly', plan: 'monthly' })}
            >
              Upgrade to Pro (placeholder)
            </button>
          </div>
        </div>

        <div className="mt-8 rounded-2xl border border-border-subtle bg-bg-elevated p-6 shadow-sm sm:p-8">
          <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
            <div>
              <h2 className="text-xl font-bold text-text-primary">Pro Yearly</h2>
              <p className="text-sm text-text-secondary">Save 20% with yearly billing</p>
            </div>
            <div className="text-left sm:text-right">
              <p className="text-3xl font-extrabold text-text-primary">$94.80</p>
              <p className="text-sm text-text-secondary">per year</p>
            </div>
          </div>
          <p className="mt-4 text-sm text-text-secondary">
            Same Pro features as Monthly, billed annually. Equivalent to $7.90/month. Payments are
            placeholder in this first version.
          </p>
          <button
            className="mt-6 w-full rounded-xl border border-primary bg-bg-elevated-2 py-3 font-semibold text-primary hover:bg-primary-50 sm:w-auto sm:px-8"
            onClick={() => track('pricing_click', { location: 'pricing_yearly', plan: 'yearly' })}
          >
            Choose Yearly (placeholder)
          </button>
        </div>

        <div className="mt-12">
          <h2 className="text-center text-2xl font-bold text-text-primary">Pricing FAQ</h2>
          <div className="mt-6">
            <FaqBlock items={PRICING_FAQ} />
          </div>
        </div>
      </section>
    </>
  );
}
